module.exports = __webpack_public_path__ + "5c12bed24c87b1e7fbf4f381af34209a.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/es/apple_store.svg
// module id = 839
// module chunks = 0